export const main = {
	yhxm:'ชื่อผู้ใช้',
	qrxx:'ยืนยันการกรอกข้อมูล',
    mmdl:'รหัสผ่านเข้าสู่ระบบ',
    yzmdl:'รหัสยืนยันเข้าสู่ระบบ',
    sjhm:"หมายเลขโทรศัพท์มือถือ",
    qsrmm:'กรุณากรอกรหัสผ่าน',
    wjmm:'ลืมรหัสผ่าน',
    dl:'เข้าสู่ระบบ',
    zcxzh:'ลงทะเบียนบัญชีใหม่',
    yzm:'รหัสยืนยัน',
    hqyzm:'รับรหัสยืนยัน',
    sryx:'ป้อนกล่องจดหมาย',
    zcsrmm:'กรอกรหัสผ่านอีกครั้ง',
    yqm:'กรุณาใส่รหัสเชิญ / หมายเลขโทรศัพท์มือถือของผู้เชิญ',
    sjyz:'การตรวจสอบโดยโทรศัพท์มือถือ',
    yxyz:'การตรวจสอบโดยกล่องจดหมาย',
    tyxyhzc:'ฉันยอมรับข้อตกลงการใช้งานและ นโยบายความเป็นส่วนตัว',
    ty:'ฉันได้อ่านและยอมรับ',
    yhxy:'ข้อตกลงการใช้งาน',
    yszc:'นโยบายความเป็นส่วนตัว',
    zce:'ลงทะเบียน',
    zyzhljdl:'มีบัญชีอยู่แล้ว เข้าสู่ระบบเดี๋ยวนี้',
    wdzc:'ทรัพย์สินของตน',
    wdzh:'บัญชีของฉันตน',
    tbgl:'การจัดการแบบซิงโครนัส',
    fbxh:'ปล่อยสัญญาณ',
    xhsc:'ตลาดสัญญาณ',
    czsc:'คู่มือการใช้งาน',
    tcxh:'สัญญาณออก',
    ye:'จำนวนดคงเหลือ',
    jz:'มูลค่าสุทธิ',
    jyss:'จำนวนหุ้นกระแสต่อการซื้อหรือขายเดียว',
    ccyl:'กำไรจากการถือหุ้น',
    xvh:'หมายเลขซีเรียล',
    sftb:'ซิงโครนัสหรือไม่',
    fwq:'เซิร์ฟเวอร์',
    zh:'บัญชี',
    zyk:'กำไรและขาดทุนทั้งหมด',
    kds:'จำนวนหุ้นกระแสต่อการซื้อหรือขายเดียวเริ่มต้น',
    zhzt:'สถานะบัญชี',
    cz:'การดำเนินงาน',
    s:'ใช่',
    f:'ไม่ใช่',
    zc:'ปกติ',
    yc:'ผิดปกติ',
    ck:'ดู',
    cpyk:'กำไรและขาดทุนของผลิตภัณฑ์',
    zss:'ปริมาณการตกลงซื้อขายตั้งแต่เปิดจนถึงทันที',
    jypz:'ประเภทของการซื้อขาย',
    sy:'กำไร',
    sszb:'อัตราส่วนจำนวนหุ้นกระแสต่อการซื้อหรือขายเดียว',
    cczh:'การถือหุ้นทั้งหมด',
    ddh:'หมายเลขการสั่งซื้อ',
    jyl:'ปริมาณการซื้อขาย',
    kcsj:'เวลาบัญชีเงินซื้อหุ้นหรือตั๋วเงินคลัง',
    kcjg:'ราคาบัญชีเงินซื้อหุ้นหรือตั๋วเงินคลัง',
    bjjg:'ทำเครื่องหมายราคา',
    zyzs:'หยุดกำไร / หยุดขาดทุน',
    gylx:'ดอกเบี้ยข้ามคืน',
    yk:'กำไรและขาดทุน',
    xzcksj:'โปรดเลือกข้อมูลที่คุณต้องการดูในบัญชี',
    tbyk:'ซิงโครไนซกำไรและขาดทุน',
    ccsj:'ระยะเวลาการถือหุ้น',
    pcsj:'เวลาการปลดปล่อยการถือหุ้น',
    tjzh:'เพิ่มบัญชี',
    bz:'หมายเหตุ',
    sfwxh:'เป็นสัญญาณหรือเปล่า',
    tbzt:'สถานะซิงโครนัส',
    ytb:'ทำให้เป็นจังหวะเดียวกันแล้ว',
    wtb:'ยังไม่ทำให้เป็นจังหวะเดียวกัน',
    qyjy:'เปิดการใช้งาน/ปิดการใช้งาน',
    yqy:'เปิดการใช้งานแล้ว',
    yjy:'ปิดการใช้งานแล้ว',
    xgzhmm:'แก้ไขรหัสผ่านและบัญชี',
    gbxh:'ปิดสัญญาณ',
    sczh:'ลบบัญชี',
    qw:'เดินทางไป',
    y:'หน้า',
    tjglzh:'เพิ่มบัญชีที่เกี่ยวข้อง',
    qxz:'กรุณาเลือก',
    qsrzh:'กรุณากรอกบัญชี',
    mm:'รหัสผ่าน',
    qsrbz:'กรุณาใส่หมายเหตุ',
    sjsqxhts:'บัญชีจริงให้การอนุญาตโดยรหัสผ่านหลักได้อัพเกรดเป็นสัญญาณชุมชน',
    qr:'ยืนยัน',
    qx:'ยกเลิก',
    zhjy:'บัญชี *****ตั้งค่าเป็นสถานะปิดการใช้งานหรือเปล่า',
    zhqy:'บัญชี *****ตั้งค่าเป็นสถานะเปิดการใช้งานหรือเปล่า',
    dqdlmm:'รหัสผ่านเข้าสู่ระบบปัจจุบัน',
    xzhmm:'รหัสผ่านบัญชีใหม่',
    qrxmm:'ยืนยันรหัสผ่านใหม่',
    qsrdqdlmm:'โปรดกรอกรหัสผ่านเข้าสู่ระบบปัจจุบัน',
    qsrxmm:'กรุณากรอกรหัสผ่านใหม่',
    qzcsrxmm:'กรุณากรอกรหัสผ่านใหม่อีกครั้ง',
    yhzl:'ข้อมูลผู้ใช้',
    jcxx:'ข้อมูลพื้นฐาน',
    tx:'รูปศีรษะ',
    sczp:'อัพโหลดรูปภาพ',
    tudxxz:'โปรดเลือกรูปภาพอัปโหลด ขนาด 413 * 626 พิกเซลล์ รองรับรูปแบบ JPG, PNG ฯลฯ รูปภาพต้องการน้อยกว่า 2M',
    gjhdq:'ประเทศและภูมิภาค',
    dzyx:'อีเมล์',
    bcxg:'บันทึกการแก้ไข',
    zhaq:'ความปลอดภัยของบัญชี',
    dqmm:'รหัสผ่านปัจจุบัน',
    xmm:'รหัสผ่านใหม่',
    qrmm:'ยืนยันรหัสผ่าน',
    qsrdqmm:'โปรดกรอกรหัสผ่านปัจจุบัน',
    qd:'ตกลง',
    tjtb:'เพิ่มความซิงโครนัส',
    tb:'ซิงโครนัส',
    xh:'สัญญาณ',
    qsrnr:'โปรดป้อนเนื้อหา',
    tbzh:'ซิงโครนัสบัญชี',
    qxztbzh:'โปรดเลือกบัญชีที่ซิงโครนัส (สามารถเลือกได้หลายแบบ)',
    jygz:'กฎการซื้อขาย',
    bzjdb:'สัดส่วของมาร์จิ้นเริ่มต้น',
    jzdb:'สัดส่วของมูลค่าสุทธิ์ ',
    kyzjdb:'อัตราเงินภายในบัญชีที่สามารถถอนเงินสดและเปิดบัญชีเงินซื้อหุ้นหรือตั๋วเงินคลังได้',
    jyldb:'อัตราปริมาณการซื้อขาย',
    gdssdb:'สัดส่วของอสังหาริมหุ้นกระแสต่อการซื้อหรือขายเดียว',
    jycs:'พารามิเตอร์การซื้อขาย',
    kcjybc:'เงินบำรุง',
    xhsxzdpc:'ปลดปล่อยการถือหุ้นเมื่อสัญญาณหมดประสิทธิภาพ',
    zdss:'จำนวนสูงสุดของหุ้นกระแสต่อการซื้อหรือขายเดียว',
    zdhc:'กางขาดทุนสูงสุดในช่วงเวลาหนึ่ง',
    jsbz:'สัญญามาตรฐานสากลเป็นเกณฑ์การคำนวณ',
    pctbts:'การปลดปล่อยการถือหุ้นบางส่วนและการปลดปล่อยการถือหุ้นจะดำเนินการตามกฎการดำเนินงานที่แตกต่างกันของปลายทางแพลตฟอร์มที่แตกต่างกันและกระบวนการซิงโครไนซ์ยังไม่สนับสนุนชั่วคราว โปรดทราบ',
    tbxh:'ทำให้เป็นสัญญาณจังหวะเดียวกัน',
    tbms:'โหมดซิงโครนัส',
    tbxs:'สัมประสิทธิ์ของการซิงโครนัซ',
    tbsz:'การตั้งซิงโครนัซ',
    xgcs:'แก้ไขพารามิเตอร์',
    yzttb:'หยุดการซิงโครนัส',
    ykqtb:'เปิดการซิงโครนัส',
    sctb:'ลบการซิงโครนัส',
    xgtbcs:'แก้ไขพารามิเตอร์การซิงโครนัส',
    cgtbzt:'แก้ไขสถานะการซิงโครนัส',
    sfqkzhdtb:'เปิดการดำเนินการซิงโครนัสของบัญชีปัจจุบัน ******* หรือไม่',
    sfztzhdtb:'หยุดการดำเนินการซิงโครนัสของบัญชีปัจจุบัน ******* หรือไม่',
    tjxh:'เพิ่มสัญญาณ',
    nsyl:'อัตราผลตอบแทนต่อปี',
    zt:'สถานะ',
    dyz:'ผู้ซิงโครนัส',
    kstbsj:'เวลาเริ่มซิงโครนัส',
    zwsj:'ไม่มีข้อมูลในขณะนี้',
    xzzh:'เลือกบัญชี',
    qxzzh:'กรุณาเลือกบัญชี',
    qqdxhhtbzzt:'โปรดตกลงสถานะปัจจุบันของสัญญาณและผู้ซิงโครนัสของคุณเพื่อหลีกเลี่ยงความเสี่ยงวัฏจักรที่ไม่มีที่สิ้นสุด',
    xhm:'ชื่อสัญญาณ',
    qsrxhm:'โปรดป้อนชื่อสัญญาณ (สูงสุด 15 ตัวอักษร)',
    xhmts:'ชื่อสัญญาณ: บัญชีหนึ่งตรงกับชื่อสัญญาณหนึ่ง จะไม่สามารถเปลี่ยนแปลงได้เมื่อยืนยันแล้ว',
    gszzdjz:'มูลค่าสุทธิ์ต่ำสุดของผู้ติดตาม',
    sfgkxh:'เปิดเผยสัญญาณหรือไม่',
    gk:'เปิดเผย',
    sm:'ส่วนตัว',
    gsddzs:'หมายเหตุติดตามการสั่งซื้อ ',
    gsddzsts:'สิ่งที่คุณกรอกที่นี่จะปรากฏในหมายเหตุการสั่งซื้อของ MT ของผู้ติดตามทั้งหมด',
    jdzyjgyhkf:'เปิดให้ผู้ใช้ระดับมืออาชีพ / ผู้ใช้สถาบันเท่านั้น',
    xhms:'คำอธิบายของสัญญาณ',
    sl:'ตัวอย่าง บัญชีนี้ทำการซื้อขายขีดสั้นป็นหลัก คำสั่งระหว่างวัน ทุกรายหยุดกำไรและหยุดขาดทุนในระดับหนึ่ง  แนะนำซิงโครไนซ์สองพันดอลลาร์หนึ่งหุ้นกระแสต่อการซื้อหรือขายเดียว',
    clmsts:'เพื่อปกป้องความเป็นส่วนตัวของผู้ใช้ทั้งหมด ไม่อนุญาตมีข้อมูลการติดต่อใด ๆ ในคําอธิบายนโยบาย แนะนำสองพันดอลลาร์',
    xhlb:'รายการสัญญาณ',
    xhlbts:'หมายเหตุ: ข้อมูลในหน้ามาจากบัญชีที่สามของแหล่งที่มาสัญญาณ สถิติข้อมูลอาจมีความล่าช้าหรือความไม่แน่นอนและข้อมูลเพียงเพื่อการอ้างอิงเท่านั้นและไม่ได้แสดงถึงผลประโยชน์ที่สามารถรับได้จริง',
    xhy:'แหล่งสัญญาณ',
    zongsyl:'อัตราผลตอบแทนรวม',
    zhousyl:'อัตราผลตอบแทนรายสัปดาห์',
    jqtjycs:'จำนวนการซื้อขายเกือบ 7 วัน',
    irrqzsy:'อัตราผลตอบแทนเฉลี่ยทางเรขาคณิตของ IRR',
    zdhc2:'กางขาดทุนสูงสุดในช่วงเวลาหนึ่ง',
    zq:'ระยะเวลาครบรอบ (วัน)',
    jbsj:'ข้อมูลพื้นฐาน',
    fx:'ใช้ร่วมกัน',
    sc:'เก็บ',
    ysc:'เก็บแล้ว',
    zsy:'รายได้รวม',
    zrj:'เงินเข้ารวม',
    zcj:'เงินออกรวม',
    zdhcl:'อัตรากางขาดทุนสูงสุดในช่วงเวลาหนึ่ง',
    zdfk:'ขาดทุนลอยสูงสุด',
    zdds:'จำนวนการสั่งซื้อทั้งหมด',
    dbzdjyl:'ปริมาณการซื้อขายสูงสุดครั้งเดียว',
    t:'วัน',
    zhhbdw:'หน่วยมาตรฐานขของเงินในบัญชี ',
    ckqb:'ดูทั้งหมด',
    anyue:'รายเดือน',
    jidu:'รายไตรมาส',
    bannian:'ครึ่งปี',
    yinian:'1 ปี',
    ernian:'2 ปี',
    sanian:'3 ปี',
    jzye:'มูลค่าสุทธิ์ / ยอดคงเหลือ ($)',
    crj:'เงินเข้าออก ($)',
    cj:'เงินออก',
    rj:'เงินเข้า',
    ysyl:'อัตราผลตอบแทนต่อเดือน',
    yiyue:'มกราคม',
    eryue:'กุมภาพันธ์',
    sanyue:'มีนาคม',
    siyue:'เมษายน',
    wuyue:'พฤษภาคม',
    liuyue:'มิถุนายน',
    qiyue:'กรกฎาคม',
    bayue:'สิงหาคม',
    jiuyue:'กันยายน',
    shiyue:'ตุลาคม',
    shiyiyue:'พฤศจิกายน',
    shieryue:'ธันวาคม',
    ccxj:'รายละเอียดการถือหุ้น',
    cq:'ผลิตภัณฑ์',
    dk:'มาก / เปล่า',
    ss:'จำนวนหุ้นกระแสต่อการซื้อหรือขายเดียว',
    yk2:'กำไร/ขาดทุน',
    hlzb:'ตัวชี้วัด',
    ylddcxsjpj:'ระยะเวลาของออเดอร์ทำกำไร (โดยเฉลี่ย)',
    ksddcxsjpj:'ระยะเวลาของออเดอร์ขาดทุน (โดยเฉลี่ย)',
    dgddylpj:'กำไรต่อคำสั่งซื้อเดี่ยว (โดยเฉลี่ย)',
    dgddkspj:'ขาดทุนต่อคำสั่งซื้อเดี่ยว (โดยเฉลี่ย)',
    dgddlrzd:'กำไรต่อคำสั่งซื้อเดี่ยว (สูงสุด)',
    dgddkszd:'ขาดทุนต่อคำสั่งซื้อเดี่ยว (สูงสุด)',
    syl:'อัตราผลตอบแทน',
    sjbl:'อัตราส่วนข้อมูล',
    sl:'อัตราการชนะ',
    zdjybl:'อัตราการซื้อขายอัตโนมัติ',
    pcddmx:'รายละเอียดการสั่งซื้อของการปลดปล่อยการถือหุ้น',
    pcjg:'ราคาการปลดปล่อยการถือหุ้น',
    sxf:'ค่าธรรมเนียม',
    tbxtccsc:'คู่มือการใช้งานระบบซิงโครนัส',
    zhzc:'ลงทะเบียนบัญชี',
    xtdl:'เข้าสู่ระบบ',
    jzhszwxh:'ตั้งบัญชีเป็นสัญญาณหรือเปล่า?',
    sztbxh:'ตั้งสัญญาณเป็นซิงโครนัส', 
    wzjs:`JCLH เป็นแพลตฟอร์มการจัดการที่ช่วยให้ผู้ใช้ปลายทางสามารถรวบรวมข้อมูลและแบ่งปันข้อมูลได้ ผู้ใช้สามารถจัดการ วิเคราะห์และสรุปสถานะการเงินและความเสี่ยงของบัญชีผ่านระบบ JCLH ระบบ JCLH ช่วยให้ผู้ใช้สามารถจัดการความสัมพันธ์ซิงโครนัสระหว่างหลายบัญชีได้
    JCLH ไม่ได้เป็นนายหน้าหรือตัวแทนจำหน่ายและไม่มีส่วนได้เสียกับสถาบันการเงินใดๆ ระบบนี้ก็ไม่ได้เป็นพ่อค้าคนกลางของสถาบันการเงินใดๆ`,
    mzsmText:`<h1 style="text-align: center; line-height: normal;">
    <span style="color: rgb(255, 255, 255);"><span style="font-family: &quot;Angsana New&quot;, serif; font-size: 22px;">แถลงการณ์การปฏิเสธความรับผิดชอบ</span></span>
</h1>
<p  style=" color: windowtext; text-align: left; ">
    <span style="font-size: 12px; color: rgb(255, 255, 255);"><span style="color: rgb(255, 255, 255); font-size: 12px; font-family: &quot;Angsana New&quot;, serif;">แถลงการณ์นี้ลงนามร่วมกันระหว่าง JCLH กับบุคคลหรือบริษัท</span><span style="color: rgb(255, 255, 255); font-size: 15px; line-height: 150%; font-family: &quot;Angsana New&quot;, serif;">ที่ได้ลงทะเบียนในเว็บไซต์ www.JCLH.bizและยอมรับข้อกำหนดและเงื่อนไขดังกล่าว</span></span>
</p>
<p  style=" color: windowtext; text-align: left; ">
    <span style="line-height: 150%; font-family: &quot;Angsana New&quot;, serif; font-size: 12px; color: rgb(255, 255, 255);">เว็บไซต์นี้ได้ดำเนินการ</span>
	<span style="line-height: 150%; font-family: &quot;Angsana New&quot;, serif; font-size: 12px; color: rgb(255, 255, 255);">อย่างระมัดระวัง</span>
	<span style="font-size: 12px; color: rgb(255, 255, 255);"><span style="color: rgb(255, 255, 255); font-size: 15px; line-height: 150%; font-family: &quot;Angsana New&quot;, serif;">และรอบคอบในการตรวจสอบข้อมูล แต่ยังไม่รับประกันว่าข้อมูลที่มีอยู่ถูกต้องทั้งหมด โปรดเข้าใจว่าข้อมูลของเราอาจไม่ครอบคลุมหรือมีการละเลยหรือล่าช้า ทั้งเว็บไซต์นี้และผู้ให้บริการข้อมูลอิสระไม่รับผิดชอบต่อการสูญเสียที่เกิดจากความผิดพลาด ความไม่สมบูรณ์ ความล่าช้า ความไม่แม่นยำของข้อมูลหรือการพึ่งพาข้อมูลในเว็บไซต์นี้ การคาดการณ์หรือมุมมองทั้งหมด (เช่น การคาดการณ์การเคลื่อนไหวของอัตราแลกเปลี่ยนในอนาคต) และกิจกรรมการซื้อขายที่เกิดขึ้นจากการคาดการณ์เหล่านี้ เป็นเพียงการแสดงความคิดเห็นและพฤติกรรมของบุคคลที่สามเท่านั้นและไม่ได้แสดงถึงจุดยืนของเว็บไซต์นี้ ขอให้คุณต้องเข้าใจว่าการคาดการณ์ของบุคคลที่สามไม่ได้แสดงถึงคำสัญญาด้านผลการดำเนินงานใด ๆ โปรดอย่าเลียนแบบทั้งทางตรงและทางอ้อม คุณต้องทำการวิเคราะห์อย่างอิสระในการตัดสินใจลงทุน ขณะเดียวกันขอให้เข้าใจว่าการตัดสินใจลงทุนตามเนื้อหาของเว็บไซต์นี้อาจสร้างผลกำไรหรือขาดทุนได้จริง</span> <span style="color: rgb(255, 255, 255); font-size: 12px; font-family: &quot;Angsana New&quot;, serif;">ถ้าคุณลงทุนโดยใช้ระบบการซื้อขายส่วนบุคคล</span><span style="color: rgb(255, 255, 255); font-size: 15px; line-height: 150%; font-family: &quot;Angsana New&quot;, serif;">ตาม</span><span style="color: rgb(255, 255, 255); font-size: 12px; font-family: &quot;Angsana New&quot;, serif;">กลยุทธ์</span><span style="color: rgb(255, 255, 255); font-size: 15px; line-height: 150%; font-family: &quot;Angsana New&quot;, serif;">และสัญญาณที่นำเสนอต่อการซื้อขายในเว็บไซต์นี้ นั่นก็คือการตัดสินใจของคุณเอง คุณต้องรับความเสี่ยงทั้งหมดด้วยตัวเอง</span></span>
</p>
<p  style=" color: windowtext; text-align: left; ">
    <span style="font-size: 12px; color: rgb(255, 255, 255);"><span style="color: rgb(255, 255, 255); font-size: 12px; font-family: &quot;Angsana New&quot;, serif;">เว็บไซต์นี้แสดงให้เห็นอย่างชัดเจนว่าแพลตฟอร์มการจัดการของเว็บไซต์นี้</span><span style="color: rgb(255, 255, 255); font-size: 15px; line-height: 150%; font-family: &quot;Angsana New&quot;, serif;">เพียง</span><span style="color: rgb(255, 255, 255); font-size: 12px; font-family: &quot;Angsana New&quot;, serif;">เหมาะสำหรับผู้ใช้ที่มีความรู้บางอย่างเกี่ยวกับการลงทุนที่มีความเสี่ยงสูงเท่านั้น</span><span style="color: rgb(255, 255, 255); font-size: 15px; line-height: 150%; font-family: &quot;Angsana New&quot;, serif;"> คุณสามารถนำเงินที่ว่างไปลงทุนได้โดยไม่ควรกระทบกับค่าใช้จ่ายในชีวิตประจำวัน กลยุทธ์การซื้อขายใด ๆ ที่สร้างผลการดำเนินงานในอดีตไม่แสดงถึงประสิทธิภาพในอนาคต โดยทั่วไปการเคลื่อนไหวของอัตราแลกเปลี่ยนในอนาคตไม่สามารถคาดการณ์ได้ กล่าวคือกลยุทธ์ส่วนบุคคล ที่ปรึกษาทางการเงิน ระบบการซื้อขายอัตโนมัติหรือทำด้วยมือใด ๆ</span> <span style="color: rgb(255, 255, 255); font-size: 15px; line-height: 150%; font-family: &quot;Angsana New&quot;, serif;">ทั้งหมดไม่สามารถรับประกันว่าการคาดการณ์ใด ๆที่สามารถสร้างผลกำไร </span><span style="color: rgb(255, 255, 255); font-size: 12px; font-family: &quot;Angsana New&quot;, serif;">ดังนั้น</span><span style="color: rgb(255, 255, 255); font-size: 15px; line-height: 150%; font-family: &quot;Angsana New&quot;, serif;">เมื่อ</span><span style="color: rgb(255, 255, 255); font-size: 12px; font-family: &quot;Angsana New&quot;, serif;">เผชิญหน้ากับการคาดการณ์การลงทุนต้องผ่านการวิเคราะห์ของตนเอง</span><span style="color: rgb(255, 255, 255); font-size: 15px; line-height: 150%; font-family: &quot;Angsana New&quot;, serif;">ก่อน</span><span style="color: rgb(255, 255, 255); font-size: 12px; font-family: &quot;Angsana New&quot;, serif;">ตัดสิน</span><span style="color: rgb(255, 255, 255); font-size: 15px; line-height: 150%; font-family: &quot;Angsana New&quot;, serif;">ใจ</span><span style="color: rgb(255, 255, 255); font-size: 12px; font-family: &quot;Angsana New&quot;, serif;">และห้ามทําตามอย่างสุ่มสี่สุ่มห้า</span></span>
</p>
<p  style=" color: windowtext; text-align: left; ">
    <span style="font-size: 12px; color: rgb(255, 255, 255);"><span style="color: rgb(255, 255, 255); font-size: 12px; font-family: &quot;Angsana New&quot;, serif;">ความล่าช้าในการส่งข้อมูลตามเว็บไซต์หรือเครือข่ายอาจทำให้เกิดความคลาดเคลื่อนของข้อมูล(รวมถึงแต่ไม่จำกัดเฉพาะการสูญหายความสัมพันธ์ในการติดตามคำสั่งซื้อเนื่องจากการขาดการเชื่อมต่อบัญชีที่อาจเกิดจากเหตุผล</span><span style="color: rgb(255, 255, 255); font-size: 15px; line-height: 150%; font-family: &quot;Angsana New&quot;, serif;">ใดใด เช่นบัญชีที่ให้สัญญาณแก้ไขรหัสผ่านหรือเหตุผล</span><span style="color: rgb(255, 255, 255); font-size: 12px; font-family: &quot;Angsana New&quot;, serif;">เครือข่ายอื่น ๆ)</span><span style="color: rgb(255, 255, 255); font-size: 15px; line-height: 150%; font-family: &quot;Angsana New&quot;, serif;"> ดังนั้นผู้ใช้ควรตรวจสอบการเปลี่ยนแปลงของข้อมูลในระบบการจัดการหลายบัญชีได้ทันเวลาหลังจากใช้ระบบซิงโครนัส ไม่ว่าจะเป็น JCLH หรือพันธมิตรใด ๆ ของเว็บไซต์นี้ไม่สามารถรับประกันได้ว่าการลงทุนของคุณขึ้นอยู่กับข้อมูลที่ได้รับจาก JCLH และการใช้ระบบซิงโครนัสการออกแบบส่วนตัวของคุณจะทำกำไรได้อย่างแน่นอน นอกจากนี้ JCLH ในฐานะที่เป็นผู้พัฒนาระบบซิงโครนัสจะไม่รับผิดชอบต่อความสูญเสียของลูกค้าอันเกิดจากความล่าช้า ความประมาทเลินเล่อของบุคคลที่สาม(เช่นบริษัทหรือตัวแทนจำหน่ายที่ให้บริการนี้) นอกเหนือจากที่กล่าวมาข้างต้น JCLH ได้ชี้แจงอย่างชัดเจนว่าจะไม่รับผิดชอบต่อกลยุทธ์และสัญญาณการซื้อขายที่เสนอโดยนักเทรดเดอร์</span></span>
</p>
<p  style=" color: windowtext; text-align: left; ">
    <span style="line-height: 150%; font-family: &quot;Angsana New&quot;, serif; font-size: 12px; color: rgb(255, 255, 255);">กฎหมายและข้อบังคับในสถานที่จดทะเบียนของบริษัท JCLH เหมาะสำหรับแถลงการณ์นี้และได้ควบคุมข้อพิพาทที่เกิดขึ้นระหว่างคู่สัญญาในแถลงการณ์นี้ เว้นแต่มีกฎหมายที่กำหนดให้ใช้บังคับอื่น ๆ ในการดำเนินการทางแพ่งหรือการดำเนินการอื่น ๆ ที่คู่สัญญาพยายามที่จะแสวงหาสิทธิ์ภายใต้แถลงการณ์นี้หรือพยายามที่จะขอประกาศสิทธิหรือหน้าที่ใด ๆ ภายใต้แถลงการณ์นี้ คู่สัญญาแต่ละฝ่ายจะต้องรับผิดชอบค่าใช้จ่ายของทนายความที่เป็นตัวแทนของตน คู่สัญญารับรองเขตอำนาจศาลพิเศษและสถานที่การ</span><a href="https://dict.longdo.com/search/%E0%B8%9E%E0%B8%B4%E0%B8%9E%E0%B8%B2%E0%B8%81%E0%B8%A9%E0%B8%B2" style="text-decoration: underline; line-height: 150%; font-family: &quot;Angsana New&quot;, serif; font-size: 12px; color: rgb(255, 255, 255);"><span style="line-height: 150%; font-family: &quot;Angsana New&quot;, serif; font-size: 12px; color: rgb(255, 255, 255);">พิพากษา</span></a><span style="line-height: 150%; font-family: &quot;Angsana New&quot;, serif; font-size: 12px; color: rgb(255, 255, 255);">ของศาล</span>
</p>
<p  style=" color: windowtext; text-align: left; ">
    <span style="line-height: 150%; font-family: &quot;Angsana New&quot;, serif; font-size: 12px; color: rgb(255, 255, 255);">ภาษาที่ตีความแถลงการณ์นี้ควรเป็นภาษาจีน</span>
</p>
<p  style=" color: windowtext; text-align: left; ">
    <span style="line-height: 150%; font-family: &quot;Angsana New&quot;, serif; font-size: 12px; color: rgb(255, 255, 255);">ในกรณีที่มีข้อขัดแย้งและไม่สอดคล้องกันระหว่างสำนวนที่ไม่ใช่ภาษาจีนกับสำนวนภาษาจีนของเอกสาร ข้อมูลและข้อความภาษาจีนควรเป็นมาตรฐาน</span>
</p>
<p>
    <br/><br/>
</p>`,
    yszcText:`<p style="font-weight: bold; color: windowtext; text-align: center; ">
    <strong>
        <span style="color: #ffffff; font-family: 微软雅黑; font-size: 22px;">
            隐私政策
        </span>
    </strong>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">感谢您使用 JCLH ！</span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        本《隐私政策》说明了我们如何收集、使用、处理和披露您的信息,包括与您访问和使用 JCLH 的个人信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        如果本《隐私政策》中有未定义的术语（如“服务项目”或“ JCLH ”），其定义和我们在服务条款中的定义一致。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        在本政策中，“ JCLH ”、“我们”或“我们的”指本《隐私政策》下对您的信息负责的 JCLH 公司。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1. 我们收集的信息类型
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

        我们主要收集三类信息。
    </span>
</p>

<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

        1.1 您向我们提供的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

        使用 JCLH 的必要信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

        当您使用 JCLH 时，我们要求您提供并收集以下您的个人信息。此等信息对于充分履行您和我们之间的合同很有必要，并使得我们能够遵守我们的法律义务。没有此等信息，我们可能无法向您提供您所要求的全部服务。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1.1.1 账号信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        在您注册 JCLH 账号时，我们要求您提供用户昵称、手机号码、电子邮件地址、密码、头像等信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1.1.2 您选择向我们提供的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您可以选择向我们提供额外的个人信息，以便在使用 JCLH 时获得更好的用户体验。此等额外信息将基于您的自愿同意而处理。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        额外个人资料信息。您可选择提供额外个人资料信息，作为您个人资料的一部分（例如首选语言、国家和地区及个人描述）。如您在账号设置中所示，部分此等个人信息是您公开个人资料页的一部分，将向其他人公开。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        交易风控信息。您可选择提供设置账户交易时使用的风控策略。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        其他信息。您还可以选择在填写表格、进行搜索、更新或添加 JCLH 账号信息或使用 JCLH 的其他功能时，向我们提供其他信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1.2 您使用 JCLH 时，我们自动收集的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        在您使用 JCLH 时，我们会自动收集关于您所使用的服务以及如何使用相关服务的信息，包括个人信息。 基于我们合法的利益理由以提供和改进 JCLH ，此等信息对于充分履行您和我们之间的合同很有必要，使得我们能够遵守法律义务。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        登录数据和设备信息。即使您未创建或登录 JCLH 账号，当您访问并使用 JCLH 时，我们也会自动收集登录数据和设备信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        Cookies 及类似技术。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        Log-In Cookies : 当您使用“在此计算机自动登录”的功能时，我们会使用持久 Cookies 。在这种情况下， Cookies 文件将永久的保存在您的计算机硬盘上，除非您使用浏览器或操作系统软件手工将其删除。当您再次使用该网站时，网站就会通过读取这些 Cookies，得知您的相关信息，就可以做出自动登录的动作。这些 Cookies 包含一个 ID 号。您的登录资料和您的密码不会被保存。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1.3 我们通过第三方收集的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        第三方平台的交易账户信息。如果您将第三方交易账户连接至 JCLH，您将授权 JCLH 获取您的第三方平台的交易账户相关信息（比如：交易商信息、账户名、只读密码、交易数据等）。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        2.我们如何使用所收集的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        我们使用、存储和处理您的信息（包括个人信息），以提供、了解、改进和发展 JCLH ，创建和维护一个受到信任的、更安全的环境，并遵守我们的法律义务。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        2.1 创建和维护一个受到信任的以及更安全的环境
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        检测和预防欺诈、滥用、安全事件及其他有害活动。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        开展安全调查和风险评估。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        对照数据库与其他信息源进行检查，包括在适用法律允许的限度内以及必要时经您同意进行背景或警方调查。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        遵守我们的法律义务。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        解决我们与任何会员之间的任何争议，并执行我们与第三方的约定。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        执行我们的服务条款及其他政策。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        3.分享与披露
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        3.1 征得您的同意
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        经您同意，我们可以按照您在同意时的指示分享您的信息（包括个人信息），如当您授权第三方应用软件或网站访问您的 JCLH 账号时。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        3.2 业务转移
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        如果 JCLH 从事或涉及任何合并、收购、重组、资产出售、破产或者资不抵债的事件，那么我们可以出售、转让或分享我们的部分或全部资产，包括与此类交易或设想的此类交易(如尽职调查)有关的您的信息。在此情况下，我们会在转移您的个人信息且令其遵守不同隐私政策之前通知您。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        3.3汇总信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        出于遵守法规、行业与市场分析、受众统计归类、营销与广告以及其他业务目的，我们也会分享汇总信息（关于我们用户的合并信息，此类信息不再识别或指向某位个人用户）和其他匿名信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        4.其他重要信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        4.1 关联第三方账号
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您通过关联账号向我们提供的一些信息可能会被存储、处理和传输，用于欺诈防范和风险评估；以及对于您通过此类链接向 JCLH 提供的信息，其发布与显示取决于您在 JCLH 和第三方网站上的设置与授权。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        5.您的权利
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您可以联系我们，在相关 JCLH 数据控制人适用之前行使本条所述的任何权利。请注意，在对您的请求采取进一步行动之前，我们可能会要求您验证您的身份。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        5.1 管理您的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您可以通过您的账号设置访问和更新您的一些信息。您有责任及时更新您的个人信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        5.2 不准确或不完整的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您有权要求我们更正您的不准确或不完整的个人信息（以及您无法在您的 JCLH 账号中自行更新的信息）。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        5.4 数据保留与删除
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您可以向官方客服申请注销帐号或删除账户信息,工作人员会在3个工作日内处理。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        通常，我们只在履行您与我们之间的合同并遵守我们的法律义务的必要时间段内保留您的个人信息。如果您不再希望我们使用您的信息来为您提供 JCLH ，您可以要求我们删除您的个人信息并关闭您的 JCLH 账号。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        请注意，如果您申请删除您的个人信息：
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        我们可能会保留您的一些个人信息，以符合我们的合法商业利益，如欺诈侦测和预防以及提高安全性。例如，如果我们因欺诈或安全原因停用了 JCLH 账号，则我们可能会保留该 JCLH 账号的某些信息，以防止该会员将来再次创建新的 JCLH 账号。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        为了遵守我们的法律义务，我们可能会保留并使用您的个人信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        即使您的 JCLH 账号被注销，您与他人分享的信息仍可以在 JCLH 上公开显示。但您对这些信息的归属信息将被删除。此外，您的信息的某些副本（如登录记录）可能会保留在我们的数据库中，但会与个人标识符区分开来。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        6. 全球运营
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        为方便我们的全球运营， JCLH 可在我们的公司内部或与服务提供商转移、存储和处理您的信息。这些国家/地区的法律或许与您居住地所适用的法律不同。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        7.安全
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        我们将持续实施和更新管理、技术和物理安全措施，保护您的信息不受未经授权的访问、损失、破坏或变更。我们用来保护您的信息的一些安全措施是防火墙和数据加密以及信息访问控制。如果您知道或有理由相信您的 JCLH 账号信息已丢失、被盗用、被挪用或遭到其他方式入侵，或者出现任何实际或怀疑盗用您的 JCLH 账号的情况，请按照以下“联系我们”一条的说明联系我们。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        8.本《隐私政策》的变更
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        JCLH 保留随时根据本条规定修改本《隐私政策》的权利。如果我们对本《隐私政策》做出变更，我们将在 JCLH 上发布变更后的《隐私政策》，并更新《隐私政策》顶端的“最后更新”日期。如果您不同意变更后的《隐私政策》，您可以注销您的账号。如果您未在变更后的《隐私政策》生效前注销您的账号，您对 JCLH 的继续访问或使用将受变更后的《隐私政策》的约束。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        9.联系我们
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        如果您对本《隐私政策》或 JCLH 的信息处理方法有任何问题或意见，您可以通过官网在线客服与我们联系，或通过 JCLH 官方提供的各种联系方式与我们联系， JCLH 将给予您帮助。
    </span>
</p>
`,
fwtkText:`<h1 style="text-align: center; line-height: normal; text-indent: 0em;">
<span style="font-size: 22px;"><strong><span style="color: rgb(255, 255, 255); font-family: 微软雅黑;">服务条款</span></strong></span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;"><span>欢迎您使用</span> JCLH 网站的服务。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">您应当阅读并遵守《 JCLH 服务条款》(以下简称“本协议”)，请您务必审慎阅读、充分理解各项条款内容。除非您已充分阅读、完全理解并接受本所有条款内容，否则您无权使用 JCLH 服务。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">本协议是由 JCLH 与在网站 www.JCLH.biz 上的已注册登记并已明确接受此等条款和条件的个人或公司共同签署。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH多账户管理系统</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH多账户管理系统可以让您实现在云端管理多平台。用户可以通过JCLH管理、分析和汇总账户财务和风险。系统允许用户通过“Copy-Trading”的方式进行跨平台订单复制。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH不是不是经纪商或交易商，也不与任何金融机构有利益、介绍或居间关系。公司专注服务被传统金融市场忽略的一大部分客户：中小企业，个人客户。我们通过技术，让资产集合、风险管理、多账户管理、策略开发成为容易上手的业务。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">风险协议</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.考虑到交易存在巨大的风险，建议您在开户及交易前充分了解相关法律条规及咨询专业意见，根据个人的财务状况、投资经验、风险偏好等相关因素，慎重选择适合您的保证金交易产品。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2. JCLH 网站上所有信息（含文字、图片、音频、视频）均出于为公众传播有益资讯信息之目的，并不意味着 JCLH 赞同其观点或构成投资建议，且 JCLH 不会向您提供任何可依赖的投资建议。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">3.投资市场存在的风险是不受 JCLH 控制或影响的，您所有的交易均由个人承担风险。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">业绩统计服务</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.您应当理解，实际投资交易的收益/亏损百分比会随着各项因素而发生变化，如初始账户余额、市场行为、跟随者的账户设置等。因此，您在进行投资过程中实际产生的收益/亏损百分比可能与JCLH 多账户管理平台中信号提供者收益/亏损百分比存在一定的差异。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2. JCLH 不保证您所使用的信号提供者信号或本网站所传播的信息能让您获得利润而不亏损，您在 JCLH 多账户管理平台上进行保证金投资的实际收益/亏损均由您本人承担， JCLH 不承担任何相关责任。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">网上风险服务</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.您理解并同意，使用互联网的交易服务存在一些风险，包括硬件、软件或互联网连接等不可控因素，如信号强度、互联网的接收或路径、设备硬件或软件配置、或互联网连接的可靠性等不可控。 JCLH 不对网络交易中出现的通讯故障、误传或延误造成的损失负任何责任。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2.贵金属等全球金融产品投资市场的波动性或非流动性可能阻碍委托以有利的价格执行，或根本无法执行。如因市场情况或您的交易商的过错而导致交易无法执行，从而造成的任何损失、损害、成本或费用</span>(<span>包括但不限于，利润损失、使用损失、直接、间接、偶发或结果性损害</span>)<span>，</span> JCLH <span>不承担任何责任。</span></span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">外部链接服务</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">您理解并同意，通过 JCLH 网站链接到其他某些网站仅出于便利而提供。因这些网站所含的信息资料不可控制， JCLH 不对这些网站或您在这些网站找到的资料作出任何承诺。 JCLH 通往这些网站的链接信息，并不构成任何类型的认可或建议。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">适用法律和管辖权</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.JCLH所属公司注册所在地法律、法规应适用于本协议以及管辖本协议各方之间引起的争议，除非存在法律指定适用其他管辖法律。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2.在合约一方寻求实现本协议下的权利，或寻求宣告本协议下的任何权利或义务的任何民事诉讼或其他诉讼过程中，各合约方应承担其代理律师的费用和支出。合约方认可专属管辖和法院审判地。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">3.本协议的解释语言应为（简体）中文。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">4.如果任何文件、信息和消息的非中文表述和中文表述之间出现矛盾和不一致的情况下，双方将以中文文件、信息和消息为标准。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">其他</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">如果您对本条款有意见或建议，可与 JCLH 客服联系， JCLH 将给予您帮助。</span>
</p>
<p>
<br/>
</p>`,
    mzsmbt:"แถลงการณ์การปฏิเสธความรับผิดชอบ",
	mzsmbt:"ข้อสงวนสิทธิ์",
	qwzxcz:"เพื่อรับประกันผลตอบแทนจากการคัดลอกบัญชี โปรดอย่าดำเนินการใดๆ ด้วยตนเอง!",
	wdzl:"ข้อมูลของฉัน",
	wdqb:"กระเป๋าเงินของฉัน",
	hyfw:"บริการสมาสมาชิก",
	wdtd:"ทีมของฉัน",
	tcdl:"ออกจากระบบ",
	xhgl:"จัดการสัญญาณ",
	sfgz:"หลักเกณฑ์ค่าค่าบริการ: ราราคาอ้างอิงจากอัตราส่วนเงินทุน 1:1 ระหว่างเงินทุนและเงินสัญญาณ; ค่าสมาชิกของผู้ใช้จะปรับปรุงแบบไดนามิกและหักรายวัน",
	jcdyf:"ค่าค่าสมามาชิกพื้นฐาน",
	yhdyf:"ค่าสมาชิกผู้ใช้",
	zhye:"ยอดคงเหลือในบัญชี",
	xhye:"ยอดสัญญาณ",
	yf:"เดือน",
	bkxzjygz:"ขณะนี้ไม่สามารถเลือกรูปแบบการเทรดได้",
	bksrjycs:"ขณะนี้ไม่สามารถป้อนพารามิเตอร์การเทรดได้",
	hand:"ล็อต",
	pcjl:"ประวัติการปิดสถานะ",
	tdxx:"ข้อมูลทีม",
	wdyqm:"รหัสเชิญของฉัน",
	fz:"คัดลอก",
	yqmsjh:"รหัสเชิญ/หมายเลขโทรศัพท์ที่แนะนำ",
	bangd:"เชื่อมโยง",
	agree:"ฉันยอมรับ",
	mzsm:"ข้อสงวนสิทธิ์",
	and:"และ",
	fwtk:"ข้อกำหนดการให้บริการ",
	qhyy:"เปลี่ยนภาษา",
	zhong:"จีน",
	ying:"อังกฤษ",
	wei:"อุยกูร์",
	tai:"ไทย",
	han:"เกาหลี",
	ri:"ญี่ปุ่น",
	kyye:"ยอด JCLHoin ที่สามารถใช้ได้",
	yets:"JCLHoin เป็นโทเค็นที่ใช้งานได้เฉพาะภายในชุมชน JCLH เท่านั้น ผู้ใช้ไม่สามารถโอนหรือแลกเป็นเงินสดระหว่างกันได้ ดำเนินการโดย JCLH สามารถรับได้โดยการแลกด้วยคะแนนที่ซื้อ JCLHoin สามารถใช้ชำระค่าสมาชิก แลกรางวัล และกิจกรรมอื่นๆ ภายในเว็บไซต์ รายละเอียดเพิ่มเติม โปรดดู 'ข้อตกลงการซื้อและการใช้งาน JCLHoin'",
	zffs:"วิธีการชำระเงิน",
	szhb:"ดิจิทัล",
	wxzf:"WeChat Pay",
	zfb:"Alipay",
	yl:"UnionPay",
	xyk:"บัตรเครดิต",
	szjl:"บันทึกการเงิน",
	szsj:"เวลา",
	szsl:"จำนวน",
	szxm:"รายการ",
	szzt:"สถานะคำสั่งซื้อ",
	szbh:"หมายเลขคำสั่งซื้อ",
	dqdj:"ระดับปัจจุบัน",
	yxq:"มีผลถึง",
	shengj:"อัปเกรด",
	hygm:"ยินดีต้อนรับสู่การซื้อสมาสมาชิก JCLH",
	zfje:"ยอดชำระ",
	xfjl:"บันทึกการใช้จ่าย",
	xfje:"จำนวนเงิน",
	dzgl:"เชื่อมโยง",
	dzg:"รายการ",
	dzzh:"บัญชี",
	
	a1:'จำนวนการซื้อ',
	a2:'ระดับสมาชิก',
	a3:'จำนวนบัญชี',
	a4:'การดำเนินการ',
	a5:'หลักฐานที่จะอัปโหลด',
	a6:'การชำระเงินสำเร็จ',
	a7:'การชำระเงินล้มเหลว',
	a8:'อัปโหลดหลักฐาน',
	a9:'ดูการชำระเงิน',
	a10:'การชำระเงิน',
	a11:'สกุลเงินดิจิทัล',
	a12:'ที่อยู่วอลเล็ต',
	a13:'คัดลอกที่อยู่',
	a14:'คัดลอกที่อยู่วอลเล็ตเพื่อชำระเงิน',
	a15:'โค้ด QR',
	a16:'จำนวนเงิน',
	a17:'ยืนยัน',
	a18:'ยกเลิก',
	a19:'ปิด',
	a20:'คัดลอกสำเร็จ',
	a21:'อัปโหลดหลักฐาน',
	a22:'ดูหลักฐาน',
	a23:'รอการตรวจสอบ',
	
	a24:'เงินประกันอัตราส่วน',
	a25:'มูลค่าใส่อัตราส่วน',
	a26:'เงินที่ใช้ได้อัตราส่วน',
	a27:'ปริมาณการซื้อขายอัตราส่วน',
	a28:'จำนวนล็อตคงที่อัตราส่วน',
	a29:'การคัดลอกเทรดในทิศทางย้อนกลับ',
	a30:'เปิดพوزิชันคอมเพนเซชัน',
	a31:'ปิดพوزิชันคอมเพนเซชัน',
	a32:'ที่เลือกแล้ว',
	a33:'บัญชีปัจจุบันเปิดใช้งานหรือไม่',
	a34:'บัญชีปัจจุบันหยุดชั่วคราวหรือไม่',
	a35:'การดำเนินการซิงค์',
	a36:'จำกัดบัญชีหนึ่ง개',
	a37:'ไม่มีข้อจำกัดจำนวนบัญชีที่ซื้อ',
	
	a38:'สมาชิกเวอร์ชันทดลองใช้',
	a39:'สมาชิกเวอร์ชันพื้นฐาน',
	a40:'สมาชิกเวอร์ชันมืออาชีพ',
	a41:'สมาชิกเวอร์ชันหน่วยงาน',
	a42:'โปรดตั้งค่าหมายเลขโทรศัพท์มือถือ',
	a43:'โปรดตั้งค่าอีเมล',
	a44:'โปรดป้อนรหัสเชิญ',
	a45:'รูปภาพโปรไฟล์ที่อัปโหลดสามารถเป็นรูปแบบ JPG เท่านั้น!',
	a46:'ขนาดรูปภาพโปรไฟล์ที่อัปโหลดไม่สามารถเกิน 2MB ได้!',
	a47:'ยังไม่มีข้อมูลซิงโครไนซ์',
	a48:'จำนวนล็อตทั้งหมด',
	a49:'จะตั้งค่าเป็นหรือไม่',
	a50:'เปิดใช้งาน',
	a51:'ปิดใช้งาน',
	a52:'สถานะ',
	a53:'คุณแน่ใจที่จะลบบัญชีนี้หรือไม่',
	a54:'คัดลอกแล้ว!',
	
	a55:'โปรดป้อนพารามิเตอร์ธุรกิจ',
	a56:'รหัสผ่านใหม่ไม่ตรงกับรหัสผ่านยืนยัน!',
	a57:'รายได้รายวัน',
	a58:'เฉลี่ย',
	a59:'สูงสุด',
	a60:'รีเฟรชสำเร็จ',
	a61:'ผลผลิต',
	a62:'ไม่ผ่านเกณฑ์',
	a63:'ผ่านเกณฑ์',
	a64:'อัตราการชนะ',
	a65:'ถอนเงิน',
	a66:'ฝากเงิน',
	a67:'ยอดคงเหลือ',
	a68:'มูลค่าศุนทรัพย์',
	a69:'กำไร/ขาดทุนรายวัน',
	a70:'โปรดป้อนค่าตัวเลข',
	a71:'สัญญานี้ยังไม่มีผู้ซิงโครไนซ์',
	
	a72:'สถานะเข้าสู่ระบบหมดอายุแล้ว โปรดเข้าสู่ระบบอีกครั้ง!',
	a73:'ข้อความ SMS ถูกส่งแล้ว โปรดตรวจสอบและรับ',
	a74:'รหัสยืนยันถูกส่งแล้ว!',
	a75:'เข้าสู่ระบบสำเร็จ!',
	a76:'ชื่อผู้ใช้ไม่สามารถเว้นว่างได้',
	a77:'หมายเลขโทรศัพท์มือถือไม่สามารถเว้นว่างได้',
	a78:'ไม่ได้ยินยันข้อตกลงผู้ใช้และนโยบายความเป็นส่วนตัว',
	a79:'อัปเกรดสมาชิก',
	a80:'เลือกประเภท',
	a81:'สถานะการใช้งานปัจจุบันจนถึง',
	a82:'สถานะการใช้งานที่คำนวณแล้วจนถึง',
	a83:'หมายเหตุ: สถานะการใช้งานที่คำนวณแล้วถูกคำนวณโดยอัตโนมัติจากระบบ',
	a84:'ดร래กไฟล์มาที่นี่ี่',
	a85:'หรือ',
	a86:'คลิกเพื่ออัปโหลด',
	a87:'คุณสมาชิกระดับสูงสุดแล้ว ไม่สามารถอัปเกรดต่อได้',
	a88:'กำลังตรวจสอบ',
	a89:'วิธีการชำระเงินนี้ไม่ได้รับการสนับสนุนชั่วคราว',
	a90:'รีเซ็ตรหัสผ่าน',
	a91:'นึกได้แล้ว',
	a92:'สหรัฐอเมริกา',
	a93:'จีน',
	a94:'ฮ่องกง',
	
	a95:'คำเตือนความเสี่ยง',
	a96:'ชุมชนควอนติทีฟอัจฉริยะแห่งนี้ให้สัญญาณการซื้อขายมาตรฐานเป็นหลัก供ผู้ใช้อ้างอิงและใช้งาน',
	a97:'เพื่อให้แน่ใจว่าประสิทธิภาพกลยุทธ์และควบคุมความล่าความจริงในการปฏิบัติ',
	a98:'แนะนำให้ขนาดกองทุนสำหรับเป้าหมายควอนติทีฟเดียวไม่ควรน้อยกว่า 20000 USD',
	a99:'ถ้ากองทุนลงทุนต่ำกว่าเกณฑ์นี้ อาจทำให้ความเสี่ยงสัมพัทธ์ขยายใหญ่เนื่องจากขนาดกองทุนไม่เพียงพอ ซึ่งส่งผลต่อเสถียรภาพกลยุทธ์',
	a100:'ก่อนที่คุณจะเริ่มการดำเนินการใดๆ โปรดตั้งอยู่บนสถานภาพการเงินและความสามารถที่จะทนความเสี่ยงของคุณเอง',
	a101:'ตั้งค่ากลไกป้องกันความเสี่ยงของบัญชีด้วยตัวคุณเอง',
	a102:'การปฏิบัติงานซื้อขายควอนติทีฟทั้งหมดเป็นการตัดสินใจด้านส่วนตัวที่เป็นอิสระของคุณ และกำไรขาดทุนที่เกี่ยวข้องและความเสียหายที่เกิดจากปัจจัยที่ไม่สามารถป้องกันได้ เช่น การผันผวนของตลาด ข้อผิดพลาดของระบบ การเปลี่ยนแปลงนโยบาย ฯลฯ',
	a103:'ทั้งหมดต้องรับผิดชอบโดยคุณเอง',
	a104:'สัญญาณที่ให้โดยชุมชนแห่งนี้ใช้อ้างอิงข้อมูลเท่านั้น',
	a105:'ไม่ประกอบเป็นคำแนะนำการลงทุน ข้อเสนอ หรือการรับรอง',
	a106:'ชุมชนควอนติทีฟอัจฉริยะแห่งนี้',
	a107:'ไม่รับผิดชอบต่อผลการซื้อขายหรือความเสียหายของกองทุนใดๆ',
	a108:'โปรดเข้าใจอย่างเต็มที่และยืนยันการยอมรับความเสี่ยงด้านบนก่อนที่จะดำเนินการ',
	a109:'ฉันเข้าใจแล้ว',
	
	zhlb:'รายการบัญชี',
	
	a110:'ยังไม่มีระดับ',
}
